'use client';

import { type CSSProperties } from 'react';

import dynamic from 'next/dynamic';

import { SIDEBAR_WIDTH, useSidebar } from '@/components/ui/sidebar';
import { usePageDirection } from '@/hooks/use-page-direction';

const Toaster = dynamic(() => import('sonner').then(mod => mod.Toaster), {
  ssr: false,
});

export function ToasterWithSidebar({ forceOverlay }: { forceOverlay?: boolean }) {
  const { open, isMobile } = useSidebar();
  const dir = usePageDirection();

  const isShifted = !isMobile && !forceOverlay && open;

  return (
    <Toaster
      id="assistant"
      position="top-center"
      closeButton
      // Soft, type-tinted toasts (per-type overrides of these vars live in
      // globals.css); merged with the sidebar-shift transform when applicable.
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          ...(isShifted
            ? {
                position: 'absolute',
                transform: `translateX(calc(-50% ${dir === 'rtl' ? '-' : '+'} ${SIDEBAR_WIDTH} / 2))`,
              }
            : {}),
        } as CSSProperties
      }
      className="!transition-transform !duration-200 !ease-linear"
      toastOptions={{
        classNames: {
          toast: '!text-sm !max-w-[calc(100vw-2rem)]',
        },
      }}
    />
  );
}
